export default __webpack_public_path__ + "static/media/03AW3NOV65.fc2b8ccb.jpg";